import React, { Component } from 'react';
import { withRouter } from 'utilities/with_router';
import { useAuth } from 'auth_context';
import loading_animation from 'animations/tqps-loading.gif';
import OrgMap from 'components/OrgMap';

class OrgThumb extends Component {
	render() {
		const users = this.props.data.users || [];
		var thumb_fields = [];

		for (let field_type of Object.keys(this.props.data)) {
			if (field_type !== 'name' && field_type !== 'users') {
				let field_data = this.props.data[field_type];
				if (!field_data.value || field_data.value.trim() === '' || field_data.value === 'None')
					continue;
				let private_text = !field_data.is_public ? (
					<div
						className="tooltip-wrapper"
						data-tooltip="Only logged-in members of the Constellation Network can see this field"
						style={{ flexShrink: 0 }}
					>
						<span className="private-text">[ private ]</span>
					</div>
				) : (
					''
				);
				thumb_fields.push(
					<h5 style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
						<span>
							{field_data.display_name}:{' '}
							<span style={{ fontWeight: 'bold' }}>{field_data.value}</span>
						</span>
						{private_text}
					</h5>
				);
			}
		}

		return (
			<div className="org-thumb-container">
				{this.props.data.name.value}
				{thumb_fields}
				{users.length > 0 && (
					<p style={{ fontWeight: 'bold', marginTop: '12px', marginBottom: 0 }}>
						{users.join(', ')}
					</p>
				)}
			</div>
		);
	}
}

class MapPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: true,
			org_list_data: [],
			map_markers: [],
		};
	}

	componentDidMount() {
		this.fetch_org_list();
	}

	fetch_org_list = async () => {
		const response = await this.props.auth.authFetch('/api/get_org_list/');
		const data = await response.json();
		this.setState({
			loading: false,
			org_list_data: data.org_list,
			map_markers: data.map_markers || [],
		});
	};

	render() {
		let org_list;
		if (this.state.loading) {
			org_list = <img className="loading-animation" src={loading_animation} />;
		} else {
			org_list = this.state.org_list_data.map((org, i) => <OrgThumb key={i} data={org} />);
		}

		return (
			<div>
				<div className="org-list-container">
					<h2 style={{ textAlign: 'center', marginTop: '10px' }}>Constellation partner orgs:</h2>
					<OrgMap markers={this.state.map_markers} />

					<div className="org-grid">{org_list}</div>
				</div>
			</div>
		);
	}
}

const Map = props => {
	const auth = useAuth();
	return <MapPage {...props} auth={auth} />;
};

export default withRouter(Map);
